/* eslint-disable no-param-reassign */
import format from 'date-fns/format';

export function getMilliSecondsTimestamp(timestamp) {
  if (typeof timestamp === 'undefined') {
    return '';
  }
  let milliTimestamp = timestamp;
  const timestampLen = timestamp.toString().length;
  const zerosToAdd = 13 - timestampLen;

  if (zerosToAdd > 0) {
    for (let i = 0; i < zerosToAdd; ) {
      milliTimestamp *= 10;
      i += 1;
    }
  }

  return milliTimestamp;
}
export function dateToStringWithFormat(timestamp, dateFormat) {
  if (timestamp && timestamp.indexOf && timestamp.indexOf('-') !== -1) {
    const nowDate = new Date(timestamp);
    timestamp = nowDate.getTime();
  }
  const validTimestamp = Number(getMilliSecondsTimestamp(timestamp));
  const date = new Date(validTimestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, dateFormat);
  if (readableTime === 'Invalid Date') return '';
  return readableTime;
}

export function getDaysRangeTimeStamp(day = 1) {
  if (typeof day === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * day + 1000,
    to: curdt,
  };
}

export function getMonthsRangeTimestamp(month = 1) {
  if (typeof month === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * 30 * month + 1000,
    to: curdt,
  };
}

export function getYearsRangeTimeStamp(year = 1) {
  if (typeof year === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * 365 * year + 1000,
    to: curdt,
  };
}

export function getDaysMiliseconds(day = 1) {
  return 1000 * 60 * 60 * 24 * day - 1000;
}

export function getMonthsMiliseconds(month = 1) {
  return 1000 * 60 * 60 * 24 * 30 * month - 1000;
}

export function getYearsMiliseconds(year = 1) {
  return 1000 * 60 * 60 * 24 * 365 * year - 1000;
}

export function dateToStringWithFormatTopic(timestamp, dateFormat) {
  if (timestamp && timestamp.indexOf && timestamp.indexOf('-') !== -1) {
    const nowDate = new Date(timestamp);
    timestamp = nowDate.getTime();
  }
  const validTimestamp = timestamp;
  const date = new Date(timestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, dateFormat);
  if (readableTime === 'Invalid Date') return '';
  return readableTime;
}

export default {
  getMilliSecondsTimestamp,
  dateToStringWithFormat,
  getDaysRangeTimeStamp,
  getMonthsRangeTimestamp,
  getYearsRangeTimeStamp,
  getDaysMiliseconds,
  getMonthsMiliseconds,
  getYearsMiliseconds,
};
